import React from 'react';
import PropTypes from 'prop-types';
import { TabButton, TabBadge, TabDot } from './styled';

const WhatsNewTab = ({
  label, active, unseen, isLatest, badgeLabel, onClick
}) => (
  <TabButton type="button" $active={ active } onClick={ onClick }>
    {label}
    {isLatest ? <TabBadge>{badgeLabel}</TabBadge> : (unseen && <TabDot />)}
  </TabButton>
);

WhatsNewTab.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  unseen: PropTypes.bool.isRequired,
  isLatest: PropTypes.bool.isRequired,
  badgeLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default WhatsNewTab;
